<nz-layout>
    <nz-header>
        <app-navbar></app-navbar>
    </nz-header>
    <app-content>
        <router-outlet></router-outlet>
    </app-content>
</nz-layout>
